import React from 'react';
import dynamic from 'next/dynamic';
import * as Dialog from '@radix-ui/react-dialog';
import {
  StyledAlertDialogContent,
  StyledAlertDialogOverlay,
} from '@/shared/ui/alert-dialog/styles';
import { createDialogOpenChangeHandler } from '@/shared/libs/dialog-open-change';

const NotAllowedContent = dynamic(
  (() => import('@/entities/game/ui/not-allowed-content').then((m) => m.NotAllowedContent)),
  {
    ssr: false,
    loading: () => null
  }
)

export const NotAllowedModal = ({ visible, onOpen, onClose }) => {

  return (
    <Dialog.Root
      open={visible}
      onOpenChange={createDialogOpenChangeHandler(onOpen, onClose)}
    >
      <Dialog.Portal>
        <StyledAlertDialogOverlay onClick={() => onClose()} />
        <StyledAlertDialogContent aria-describedby="" data-item="game_not_allowed">
          <NotAllowedContent
            onClick={onClose}
            onClick1={() => onClose()}
          />
        </StyledAlertDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
